import { TAppRootState } from '@store/reducer';

export const alarmHistory = (state: TAppRootState) => state.alarmHistory;
export const alarmManagement = (state: TAppRootState) => state.alarmManagement;
export const allCells = (state: TAppRootState) => state.allCells;
export const approveUnit = (state: TAppRootState) => state.approveUnit;
export const assetCartRequestAvailableListSelector = (state: TAppRootState) => state.assetCartRequestAvailableList;
export const assetCartRequestFullView = (state: TAppRootState) => state.assetCartRequestFullView;
export const assetCartRequestUnavailableListSelector = (state: TAppRootState) => (
	state.assetCartRequestUnavailableList
);
export const activeAlarms = (state: TAppRootState) => state.activeAlarms;
export const activeAlarmsFlexidas = (state: TAppRootState) => state.activeAlarmsFlexidas;
export const alarmHistoryFlexidas = (state: TAppRootState) => state.alarmHistoryFlexidas;
export const alarmManagementFlexidas = (state: TAppRootState) => state.alarmManagementFlexidas;
export const assetHistory = (state: TAppRootState) => state.assetHistory;
export const assetProfileIncomingRequests = (state: TAppRootState) => state.assetProfileIncomingRequests;
export const assetProfileOutgoingRequests = (state: TAppRootState) => state.assetProfileOutgoingRequests;
export const assetRentIncomingRequestsSelector = (state: TAppRootState) => state.assetsRentIncomingRequests;
export const assetRentOutgoingRequestsSelector = (state: TAppRootState) => state.assetsRentOutgoingRequests;
export const assets = (state: TAppRootState) => state.assets;
export const assignApprovalUnit = (state: TAppRootState) => state.assignApprovalUnit;
export const auth = (state: TAppRootState) => state.auth;
export const common = (state: TAppRootState) => state.common;
export const configurationManagement = (state: TAppRootState) => state.configurationManagement;
export const crowdCells = (state: TAppRootState) => state.crowdCells;
export const dashboardPOAssetTypesTable = (state: TAppRootState) => state.dashboardPOAssetTypesTable;
export const dashboardPORequestsTable = (state: TAppRootState) => state.dashboardPORequestsTable;
export const dashboardPOStatusesTable = (state: TAppRootState) => state.dashboardPOStatusesTable;
export const dataSourceGNBConfiguration = (state: TAppRootState) => state.dataSourceGNBConfiguration;
export const errors = (state: TAppRootState) => state.errors;
export const importMapData = (state: TAppRootState) => state.importMapData;
export const kpi = (state: TAppRootState) => state.kpi;
export const kpiAlerts = (state: TAppRootState) => state.kpiAlerts;
export const kpiAlertsHistory = (state: TAppRootState) => state.kpiAlerts.history;
export const manageAcquiredAssets = (state: TAppRootState) => state.manageAcquiredAssets;
export const map = (state: TAppRootState) => state.map;
export const moBranch = (state: TAppRootState) => state.moBranch;
export const moBranches = (state: TAppRootState) => state.moBranches;
export const notifications = (state: TAppRootState) => state.notifications;
export const organisationBranding = (state: TAppRootState) => state.organisationBranding;
export const organisationProjects = (state: TAppRootState) => state.organisationProjects;
export const organisationSettings = (state: TAppRootState) => state.organisationSettings;
export const organisations = (state: TAppRootState) => state.organisations;
export const portalFiles = (state: TAppRootState) => state.portalFiles;
export const portalFolders = (state: TAppRootState) => state.portalFolders;
export const portalMilestones = (state: TAppRootState) => state.portalMilestones;
export const portalProjects = (state: TAppRootState) => state.portalProjects;
export const portalTasks = (state: TAppRootState) => state.portalTasks;
export const portalTimeline = (state: TAppRootState) => state.portalTimeline;
export const schemaConfig = (state: TAppRootState) => state.schemaConfig;
export const sectors = (state: TAppRootState) => state.sectors;
export const sites = (state: TAppRootState) => state.sites;
export const userHistory = (state: TAppRootState) => state.userHistory;
export const users = (state: TAppRootState) => state.users;
